import { ModalWrapper } from 'src/components/ModalWrapper';
import { EventShopModalContainer } from './components/ShopModalContainer';
import { Button } from 'src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { EventShopModalProps } from './types';
import { useModalContext } from 'src/hooks/useModalContext';
import { useBuyItemHandler } from './hooks/useBuyItemHandler';
import { BuyMoney } from 'src/pages/EventShop/AuthorizedEventShop/components/BuyMoney';

export const BuyMoneyEventModal = () => {
  const { modalProps } = useModalContext<EventShopModalProps>();
  const { handleClick } = useBuyItemHandler();
  const { t } = useTranslation();

  return (
    <ModalWrapper showCross={false} isTransparentBg>
      <EventShopModalContainer title="christmasShop.bonusMoney" text="christmasShop.doYouWant">
        <div className="flex flex-col mb-[50px]">
          <BuyMoney item={modalProps?.item} />
          <Button className="w-[165px] self-center" onClick={handleClick}>
            {t('christmasShop.accept')}
          </Button>
        </div>
      </EventShopModalContainer>
    </ModalWrapper>
  );
};
